/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rating_Neither_Satisfied_Nor_DissatisfiedInputs */

const sv_rating_neither_satisfied_nor_dissatisfied = /** @type {(inputs: Rating_Neither_Satisfied_Nor_DissatisfiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varken nöjd eller missnöjd`)
};

const en_rating_neither_satisfied_nor_dissatisfied = /** @type {(inputs: Rating_Neither_Satisfied_Nor_DissatisfiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neither satisfied nor dissatisfied`)
};

/**
* | output |
* | --- |
* | "Neither satisfied nor dissatisfied" |
*
* @param {Rating_Neither_Satisfied_Nor_DissatisfiedInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const rating_neither_satisfied_nor_dissatisfied = /** @type {((inputs?: Rating_Neither_Satisfied_Nor_DissatisfiedInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rating_Neither_Satisfied_Nor_DissatisfiedInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_rating_neither_satisfied_nor_dissatisfied(inputs)
	return en_rating_neither_satisfied_nor_dissatisfied(inputs)
});